<div [class.enabled]="!isDisabled">
  <mat-checkbox (change)="changeCheckbox($event)" [checked]="isChecked"></mat-checkbox>
</div>
<div [class.enabled]="!isDisabled" (click)="toggleBox()">
  {{ elementName }}
  <ng-content></ng-content>
</div>
